import { MODULE_NAME as CAMPAIGNS_MODULE } from 'modules/campaigns/config/routes/module';
import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import { realtimeReportVisibilityCondition } from '../../../../../config/report-predicates/realtimeReportVisibilityCondition';
import * as FIELDS from '../../fields';
import { FILTER_TYPE } from '../../filters';
import { REPORT_PRESET } from '../../pickers';
import { normalizedPlatformReportColumnDefinition } from './columnDefinitions';
import { platformReportFooterColumnDefinition } from './footerColumnDefinitions';
import { graphConfigs } from './graph';
import { PLATFORM_REALTIME_REPORT_ID } from './platformRealtimeReportId';
import { defaultColumns, customColumns } from './reportPresets';

export const platformRealtimeReportByPlatformConfig = {
    id: PLATFORM_REALTIME_REPORT_ID,
    label: 'Platforms',
    permissions: ['TA_REAL_TIME_REPORT'],
    accountConfigurations: { [FEATURE_FLAGS.ONLY_PERFORMANCE_REPORTS]: 'false' },
    visibilityCondition: realtimeReportVisibilityCondition,
    module: CAMPAIGNS_MODULE,
    endpoint: 'campaign-realtime-report-by-platform',
    graph: graphConfigs,
    rowIdField: FIELDS.PLATFORM_CODE.field,
    columnsDef: normalizedPlatformReportColumnDefinition,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    sortMap: {
        [FIELDS.PLATFORM_CODE.field]: 'platform',
        [FIELDS.AVERAGE_CPC.field]: 'cpc',
        [FIELDS.CONVERSIONS.field]: 'cpaActionsNum',
        [FIELDS.CONVERSIONS_CLICKS.field]: 'cpaActionsNumFromClicks',
        [FIELDS.CONVERSIONS_VIEWS.field]: 'cpaActionsNumFromViews',
        [FIELDS.CVR.field]: 'cpaConversionRate',
        [FIELDS.CVR_CLICKS.field]: 'cpaConversionRateClicks',
        [FIELDS.CVR_VIEWS.field]: 'cpaConversionRateViews',
    },
    footerColumnDef: platformReportFooterColumnDefinition,
    customRestrictedFilters: {},
    filters: [
        {
            id: FILTER_TYPE.COUNTRY,
            permissions: ['TA_REAL_TIME_REPORT_FILTERS'],
        },
        {
            id: FILTER_TYPE.SITE,
            permissions: ['TA_REAL_TIME_REPORT_FILTERS'],
        },
    ],
};

export default platformRealtimeReportByPlatformConfig;
